import { atom } from "recoil"

export type NavigationCursorState = {
	isVisible: boolean
	layoutGroupId: string | null
	cursorTime: number | null
}

export const navigationCursorAtom = atom<NavigationCursorState>({
	key: "navigationCursor",
	default: {
		isVisible: false,
		layoutGroupId: null,
		cursorTime: null,
	},
})
